import * as React from "react";
import * as style from "./Offers.style";
import { IKImage } from "imagekitio-react";
import { classes } from "typestyle";
import { Link } from "react-router-dom";
import { hooks } from "../../utility";
import { Helmet } from "react-helmet";
import { Button } from "../../components";
import sunsetCruise from "../../../public/assets/sunset-cruise.jpg";
import krakenImage from "../../../public/assets/kraken-on-water.jpeg";
import bacheloretteSandbar from "../../../public/assets/bachelorette-boat-cruise-sandbar.jpeg";
import wildlifeImage from "../../../public/assets/wildlife.jpeg";

const Offers: React.FC = () => {
  const display = hooks.useDisplayContext();
  return (
    <>
      <Helmet>
        <title>Delaware Boat Rentals</title>
        <meta
          name="description"
          content="Delaware Boat Rentals - Every different type of DE boat rental or charter available here. Book Now!"
        />
      </Helmet>
      <div className={style.component}>
        <div className={style.topBorder} />
        <div className={style.section}>
          <IKImage
            className={style.logoLeft}
            alt="The Octolounge Logo"
            path="/logos/octolounge-logo-only.png"
          />
          {!display.isMobile && <div className={style.leftPhoto} />}
          <div className={style.rightContentContainer}>
            <div className={style.rightContentBackground} />
            <div className={style.rightContent}>
              <div className={style.title}>The Octolounge</div>
              <div className={style.subTitle}>
                2, 3, or 4 Hour Options &bull; All Ages &bull; Private Group of
                Up to 13 People
              </div>
              <div className={style.options}>
                Our most popular options to choose from are:
              </div>
              <div className={style.option}>
                <span style={{ fontWeight: 700 }}>Sandbar Outing: </span>
                Massey's Landing sandbar, located in the Rehoboth Bay, is where
                the locals hang out on a hot summer day! Spend the day relaxing
                in the shallow waters of the Bay while enjoying music, games and
                our selection of floats to lounge on. Great fun for children and
                adults!
              </div>
              <div className={style.option}>
                <span style={{ fontWeight: 700 }}>Bar Hopping:</span> The
                Octolounge is the Rehoboth Bay charter boat that lets you go bar
                hopping with your own personal "DD". Our Captains can take you
                from Lewes to Rehoboth to Dewey, anywhere you want to go!
              </div>
              <div className={style.option}>
                <span style={{ fontWeight: 700 }}>Happy Hour:</span> It doesn't
                get any better than pregaming your night on the town out on the
                water. Book us for Happy Hour and we can drop you back off at
                our slip in downtown Dewey Beach!
              </div>
              <IKImage
                className={style.mobileImage}
                alt="Rehoboth Beach Hourly Cruise"
                path="/rehoboth-bay-boat-cruise.png"
              />
              <Link to="/hourly" className={style.link}>
                <div className={style.moreInfo}>
                  <Button rounded={false}>More Info</Button>
                </div>
              </Link>
            </div>
          </div>
        </div>
        <div className={style.section}>
          <IKImage
            className={style.logoRight}
            alt="The Octolounge Logo"
            path="/logos/octolounge-logo-only.png"
          />
          <div className={style.leftContainerExtraTall}>
            <div className={style.leftBackgroundExtraTall} />
            <div className={style.leftContent}>
              <div className={style.leftTitle}>The Kraken</div>
              <div className={style.leftSubTitle}>
                2, 3, or 4 Hour Options &bull; All Ages &bull; Private Group of
                Up to 13 People
              </div>
              <div className={style.howItGoes}>Description:</div>
              <div className={style.leftDescription}>
                The only double-decker pontoon with a slide on Rehoboth Bay, the
                Kraken is built for unforgettable days on the water. It's a
                go-to for bachelorette parties on the weekends, while weekdays
                transform it into the perfect family-friendly adventure.
              </div>
              <div className={style.leftDescription}>
                The Kraken cruises to the bay's most popular swimming spots and
                deeper sandbars, and while it's slightly slower than the
                Octolounge, it more than makes up for it with extra space, a
                rooftop sun deck, a slide, and nonstop fun. Don't forget about
                the attached inflatable dock that creates the ideal space to
                relax, float, and soak it all in.
              </div>
              <div className={style.howItGoes}>Popular trips include:</div>
              <div className={style.leftDescription}>
                • Slide &amp; Swim Trips
                <br />
                • Sandbar Trips (dependent on tides)
                <br />
                • Canal Cruises
                <br />
                • Sunset Swims
                <br />• Morning Swims
              </div>
              <img
                className={style.mobileImage}
                alt="The Kraken Double Decker Pontoon"
                src={krakenImage}
              />
              <Link to="/kraken" className={style.link}>
                <div className={style.moreInfo}>
                  <Button rounded={false}>More Info</Button>
                </div>
              </Link>
            </div>
          </div>
          {!display.isMobile && (
            <img
              className={style.rightPhotoExtraTall}
              alt="The Kraken Double Decker Pontoon"
              src={krakenImage}
              style={{ objectFit: "cover" }}
            />
          )}
        </div>
        <div className={style.section}>
          <IKImage
            className={style.logoLeft}
            alt="The Octolounge Logo"
            path="/logos/octolounge-logo-only.png"
          />
          {!display.isMobile && (
            <IKImage
              className={style.leftPhotoTall}
              alt="Dewey Beach Bachelorette Party Booze Cruise"
              path="/dewey-beach-bachelorette-party-booze-cruise.png"
            />
          )}
          <div className={style.rightContentContainerTall}>
            <div className={style.rightContentBackgroundTall} />
            <div className={style.rightContent}>
              <div className={style.title}>Morning Mimosa Cruise</div>
              <div className={style.subTitle}>
                2 Hours &bull; All Ages &bull; Private Group of Up to 13 People
              </div>
              <div className={style.options}>How it goes:</div>
              <div className={style.option}>
                There are not a lot of things more relaxing than a morning on
                the water.
              </div>
              <div className={style.option}>
                Pick your boat and embrace the morning sun on our Mimosa Cruise!
                Sip on your beverage of choice - whether it's mimosas, coffee,
                or whatever floats your boat. Recline, let go, and absorb the
                breathtaking scenery of the Delaware shores and waterfront real
                estate. It's the perfect way to start your day at the beach!
              </div>
              <IKImage
                className={style.mobileImage}
                alt="Dewey Beach Bachelorette Party Booze Cruise"
                path="/dewey-beach-bachelorette-party-booze-cruise.png"
              />
              <Link to="/morning" className={style.link}>
                <div className={style.moreInfo}>
                  <Button rounded={false}>More Info</Button>
                </div>
              </Link>
            </div>
          </div>
        </div>
        <div className={style.section}>
          {!display.isMobile && (
            <IKImage
              className={style.logoRight}
              alt="The Octolounge Logo"
              path="/logos/octolounge-logo-only.png"
            />
          )}
          <div
            className={classes(
              style.leftContentContainer,
              style.leftShortContainer
            )}
          >
            <div
              className={classes(
                style.leftContentBackground,
                style.leftShortBackground
              )}
            />
            <div className={style.leftContent}>
              <div className={style.leftTitle}>Sunset Cruise</div>
              <div className={style.leftSubTitle}>
                2 Hours &bull; All Ages &bull; Private Group of Up to 13 People
              </div>
              <div className={style.howItGoes}>Description:</div>
              <div className={style.leftDescription}>
                The sunset cruise is one of our most popular trips. Available on
                both the Octolounge and the Kraken, each offers a relaxed cruise
                through canals or along waterfront homes—with the option for a
                swim.
              </div>
              <div className={style.leftDescription}>
                For the best sunset view on the bay, nothing beats the Kraken's
                top deck.
              </div>
              <img
                className={style.mobileImage}
                alt="Dewey Beach Booze Cruise"
                src={sunsetCruise}
              />
              <Link to="/sunset" className={style.link}>
                <div className={style.moreInfo}>
                  <Button rounded={false}>More Info</Button>
                </div>
              </Link>
            </div>
          </div>
          {!display.isMobile && (
            <div
              className={classes(style.rightPhoto, style.leftBoozeCruiseImage)}
            />
          )}
        </div>
        <div className={style.section}>
          <IKImage
            className={style.logoLeft}
            alt="The Octolounge Logo"
            path="/logos/octolounge-logo-only.png"
          />
          {!display.isMobile && (
            <img
              className={style.leftPhotoTall}
              alt="Rehoboth Bay Wildlife Tour"
              src={wildlifeImage}
              style={{ objectFit: "cover" }}
            />
          )}
          <div className={style.rightContentContainerTall}>
            <div className={style.rightContentBackgroundTall} />
            <div className={style.rightContent}>
              <div
                className={style.title}
                style={{ whiteSpace: display.isMobile ? "normal" : "nowrap" }}
              >
                History &amp; Wildlife Tour
              </div>
              <div className={style.subTitle}>
                2 Hours &bull; All Ages &bull; Private Group of Up to 13 People
              </div>
              <div className={style.options}>
                There are two options for our Historical Tour:
              </div>
              <div className={style.option}>
                <span style={{ fontWeight: 600 }}>Lewes Tour: </span>We will
                take a ride down the Rehoboth Lewes Canal and then directly
                through the town of Lewes! We can even stop by Kings Creamery
                for some of the best ice cream at the beach!
              </div>
              <div className={style.option}>
                <span style={{ fontWeight: 600 }}>Indian River Inlet: </span>We
                will cruise through the Rehoboth Bay over to the Inlet while
                talking about the rich history of Delaware's Inland Bays. During
                the tour we could even stop by the Sandbar for a dip or head
                over to Seaside bar for a cocktail.
              </div>

              <div className={style.options}>
                We also offer a Wildlife Tour:
              </div>
              <div className={style.option}>
                Rehoboth Bay is full of all types of Wildlife! Birds such as
                ospreys and bald eagles and marine life like dolphins and
                horseshoe crabs are just a few of the creatures you can expect
                to see out on the water! Come join us for a day of sightseeing
                on the boat!
              </div>
              <img
                className={style.mobileImage}
                alt="Rehoboth Bay Wildlife Tour"
                src={wildlifeImage}
              />
              <Link to="/history" className={style.link}>
                <div className={style.moreInfo}>
                  <Button rounded={false}>More Info</Button>
                </div>
              </Link>
            </div>
          </div>
        </div>
        <div className={style.section}>
          {!display.isMobile && (
            <IKImage
              className={style.logoRight}
              alt="The Octolounge Logo"
              path="/logos/octolounge-logo-only.png"
            />
          )}
          <div
            className={classes(
              style.leftContentContainer,
              style.leftShortContainer
            )}
          >
            <div
              className={classes(
                style.leftContentBackground,
                style.leftShortBackground
              )}
            />
            <div className={style.leftContent}>
              <div className={style.leftTitle}>Dinner Cruise</div>
              <div className={style.leftSubTitle}>
                2 Hours &bull; All Ages &bull; Private Group of Up to 13 People
              </div>
              <div className={style.howItGoes}>Description:</div>
              <div className={style.leftDescription}>
                Looking to head into Rehoboth or Lewes for dinner? Maybe even
                Paradise Grille? Why take an uber when you can take the
                Octolounge? Our captain drops you off and picks you up from your
                dinner destination.
              </div>
              <div className={style.leftDescription}>
                Grab your friends and family, let us know where you're going to
                dinner, and leave the rest to us! Bring some drinks to have on
                the water to and from your dinner as well! Maybe you'll even
                catch the sunset.
              </div>
              <IKImage
                className={style.mobileImage}
                alt="Lewes Delaware Dinner Cruise"
                path="/lewes-delaware-dinner-cruise.jpg"
              />
              <Link to="/dinner" className={style.link}>
                <div className={style.moreInfo}>
                  <Button rounded={false}>More Info</Button>
                </div>
              </Link>
            </div>
          </div>
          {!display.isMobile && (
            <div
              className={classes(style.rightPhoto, style.leftDinnerCruiseImage)}
            />
          )}
        </div>
        <div className={style.section}>
          <IKImage
            className={style.logoLeft}
            alt="The Octolounge Logo"
            path="/logos/octolounge-logo-only.png"
          />
          {!display.isMobile && (
            <img
              className={style.leftPhotoShort}
              alt="The Floatilla Boat Combo"
              src={bacheloretteSandbar}
            />
          )}
          <div
            className={classes(
              style.rightContentContainer,
              style.rightShortContainer
            )}
          >
            <div
              className={classes(
                style.rightContentBackground,
                style.rightShortBackground
              )}
            />
            <div className={style.rightContent}>
              <div className={style.title}>The Floatilla</div>
              <div className={style.subTitle}>
                Up to 26 Guests &bull; All Ages &bull; Two Boats, Two Captains
              </div>
              <div className={style.options}>Description:</div>
              <div className={style.option}>
                Can't pick just one boat? Choose both and get the ultimate
                on-the-water experience with the Octolounge and the Kraken—truly
                the best of both worlds for groups of up to 26 people.
              </div>
              <div className={style.option}>
                With two experienced captains dedicated to your group, you can
                customize the day however you'd like. Anchor up, tie the boats
                together, and create one massive double-boat float for an
                unforgettable day on the water.
              </div>
              <img
                className={style.mobileImage}
                alt="The Floatilla Boat Combo"
                src={bacheloretteSandbar}
              />
              <Link to="/floatilla" className={style.link}>
                <div className={style.moreInfo}>
                  <Button rounded={false}>More Info</Button>
                </div>
              </Link>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

Offers.displayName = "Offers";
export { Offers };
